"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstellationUtils = void 0;
class ConstellationUtils {
    static getMedia(listingWithEnhancement) {
        return [
            ...this.getPhotos(listingWithEnhancement),
            ...this.getFloorPlans(listingWithEnhancement),
            ...this.getVideos(listingWithEnhancement),
            ...this.getVirtualTours(listingWithEnhancement)
        ];
    }
    static _getMediaType(listingWithEnhancement, mediaCategory, fieldName) {
        var _a, _b, _c, _d;
        if (!listingWithEnhancement) {
            throw Error('listingWithEnhancement is required');
        }
        else if (!mediaCategory) {
            throw Error('Media category is required');
        }
        else if (!fieldName) {
            throw Error('Field name is required');
        }
        else if (!((_a = listingWithEnhancement.Enhancement) === null || _a === void 0 ? void 0 : _a.length)) {
            throw Error('There is no Enhancement field on this listing');
        }
        const metadata = (_b = listingWithEnhancement.Enhancement) === null || _b === void 0 ? void 0 : _b[0];
        if (mediaCategory === 'Virtual Tour') {
            if (metadata.UseEvaVirtualTours) {
                return ((_c = metadata.Media) === null || _c === void 0 ? void 0 : _c.filter((media) => { var _a; return (_a = media.MediaCategory) === null || _a === void 0 ? void 0 : _a.includes('Virtual Tour'); })) || [];
            }
            else {
                return [
                    ...(listingWithEnhancement.VirtualTourURLUnbranded ? [{
                            Id: 'from listing.VirtualTourURLUnbranded',
                            MediaCategory: 'Branded Virtual Tour',
                            MediaURL: listingWithEnhancement.VirtualTourURLUnbranded,
                        }] : []),
                    ...(listingWithEnhancement.VirtualTourURLBranded ? [{
                            Id: 'from listing.VirtualTourURLBranded',
                            MediaCategory: 'Unbranded Virtual Tour',
                            MediaURL: listingWithEnhancement.VirtualTourURLBranded,
                        }] : []),
                    ...(listingWithEnhancement.AdditionalVirtualTourURL1 ? [{
                            Id: 'from listing.AdditionalVirtualTourURL1',
                            MediaCategory: 'Virtual Tour',
                            MediaURL: listingWithEnhancement.AdditionalVirtualTourURL1,
                        }] : []),
                ];
            }
        }
        const mediaArray = metadata[fieldName] ? metadata.Media : listingWithEnhancement === null || listingWithEnhancement === void 0 ? void 0 : listingWithEnhancement.Media;
        return (_d = (mediaArray || [])) === null || _d === void 0 ? void 0 : _d.filter((media) => { var _a; return (_a = media.MediaCategory) === null || _a === void 0 ? void 0 : _a.includes(mediaCategory); });
    }
    static getPhotos(listingWithEnhancement) {
        return this._getMediaType(listingWithEnhancement, 'Photo', 'UseEvaPhotos');
    }
    static getFloorPlans(listingWithEnhancement) {
        return this._getMediaType(listingWithEnhancement, 'Floor Plan', 'UseEvaFloorPlans');
    }
    static getVideos(listingWithEnhancement) {
        return this._getMediaType(listingWithEnhancement, 'Video', 'UseEvaVideos');
    }
    static getVirtualTours(listingWithEnhancement) {
        return this._getMediaType(listingWithEnhancement, 'Virtual Tour', 'UseEvaVirtualTours');
    }
    static getCoordinates(listingWithEnhancement) {
        var _a, _b, _c;
        const metadata = (_a = listingWithEnhancement.Enhancement) === null || _a === void 0 ? void 0 : _a[0];
        if (((_b = metadata === null || metadata === void 0 ? void 0 : metadata.Coordinates) === null || _b === void 0 ? void 0 : _b.Lat) && ((_c = metadata === null || metadata === void 0 ? void 0 : metadata.Coordinates) === null || _c === void 0 ? void 0 : _c.Lon)) {
            return metadata.Coordinates;
        }
        const { Latitude, Longitude, RawMlsLatitude, RawMlsLongitude } = listingWithEnhancement;
        if (Latitude && Longitude) {
            return { Lat: Latitude, Lon: Longitude };
        }
        else if (RawMlsLatitude && RawMlsLongitude) {
            return { Lat: RawMlsLatitude, Lon: RawMlsLongitude };
        }
        return null;
    }
    static getPublicRemarks(listingWithEnhancement, language) {
        var _a, _b, _c, _d;
        if (!listingWithEnhancement || !((_a = listingWithEnhancement.Enhancement) === null || _a === void 0 ? void 0 : _a.length)) {
            throw Error('listingWithEnhancement with an Enhancement field is required');
        }
        const metadata = (_b = listingWithEnhancement.Enhancement) === null || _b === void 0 ? void 0 : _b[0];
        if ((metadata === null || metadata === void 0 ? void 0 : metadata.UseEvaPublicRemarks) && !metadata.PublicRemarks) {
            return '';
        }
        if ((metadata === null || metadata === void 0 ? void 0 : metadata.UseEvaPublicRemarks) && !language) {
            throw Error('If UseEvaPublicRemarks is true, language is required');
        }
        const useEvaPublicRemarks = (metadata === null || metadata === void 0 ? void 0 : metadata.UseEvaPublicRemarks) || false;
        if (!useEvaPublicRemarks)
            return (_c = listingWithEnhancement.PublicRemarks) !== null && _c !== void 0 ? _c : '';
        if (metadata.PublicRemarks && metadata.PublicRemarks[language])
            return (_d = metadata.PublicRemarks[language]) !== null && _d !== void 0 ? _d : '';
        return '';
    }
}
exports.ConstellationUtils = ConstellationUtils;
//# sourceMappingURL=constellation-utils.js.map